/*
 * Ankur Mursalin
 *
 * https://encryptioner.github.io/
 *
 * Created on Wed Apr 16 2025
 */

import type {
  IStyleConfig,
  IViewConfig,
} from '@/types';

export const defaultViewConfig: IViewConfig = {
  landingPage: {
    contactInfo: {
      theme: 2,
    },
    feedbackSubmitBtn: {
      theme: 2,
    },
    heroBanner: {
      isHidden: false,
      theme: 2,
      title: 'ক্লাস, এক্সাম সব কিছু হাতের মুঠোয়!',
      imageInfo: {
        src: '',
        altText: 'Hero Banner Image',
      },
      description: 'সাজেশন ভিত্তিক স্টাডিপ্ল্যান এবং গাইডেড  জার্নির মাধ্যমে নিয়ে নিন শেষ মহুর্তের প্রস্তুতি',
      actionBtn: {
        text: 'Explore Now',
        url: 'https://biddaan.com/',
      },
      note: '৬ লাখ+ শিক্ষার্থী নিয়মিত ভাবে যুক্ত হচ্ছে লাইভ ক্লাস গুলোতে',
    },
    upcomingCourses: {
      theme: 2,
    },
    runningCourses: {
      theme: 2,
    },
  },
  navbar: {
    theme: 1,
    imageAvatarBg: {
      theme: 2,
    },
  },
  dynamicRoutes: [],
  routeModals: [],
};

export const defaultStyleConfig: IStyleConfig = {
  colors: {
    bgColor: 'white',
    divColor: 'white',
    cardColor: '#F6F6F6',
    footerColor: '#2A2E34',
    headerColor: '#F8F8F8',
    textColor: 'black',
    selectedTextColor: '#174267',
    infoBgColor: '#664494',
    infoTextColor: 'white',
    loaderPrimary: '#8338EA',
    loaderSecondary: '#FC0270',
  },
};
